import request from "@/utils/request";

export function genImg() {
  return request({
    url: "/djmx/login/genImg",
    method: "post",
  });
}
export function refreshToken(data) {
  return request({
    url: "/permission/refresh-token",
    method: "post",
    headers: {
      "Content-Type": "form-data; charset=UTF-8",
    },
    data,
  });
}
// 登录
export function login(data) {
  return request({
    url: "/permission/loginTrainingPlatform",
    method: "post",
    data: data,
  });
}
export function logout(data) {
  return request({
    url: "/permission/logout",
    method: "post",
    data: data,
  });
}
//获取验证码
export function sendSmsCode(data) {
  return request({
    url: "/permission/send-sms-code",
    method: "post",
    data,
  });
}
export function resetPassword(data) {
  return request({
    url: "/permission/resetPassword",
    method: "post",
    data,
  });
}
export function loginAndRegisterPC(data) {
  return request({
    url: "/permission/loginAndRegisterPC",
    method: "post",
    data,
  });
}
export function qRCodeGeneration(data) {
  return request({
    url: "/permission/qRCodeGeneration",
    method: "post",
    data,
  });
}

export function checkLoginStatus(data) {
  return request({
    url: "/permission/checkLoginStatus",
    method: "post",
    data,
  });
}

/* 修改用户信息 */
export function modifyUserMessage(data) {
  return request({
    url: "/permission/modifyUserMessage",
    method: "post",
    data,
  });
}
/* 获取用户信息 */
export function getUserMessage(data) {
  return request({
    url: "/permission/getUserMessage",
    method: "post",
    data,
  });
}
